import React from "react";

function TwoCompoentColSkeleton() {
  return (
    <div className="flex gap-4">
      <div className="flex w-[25%] flex-col">
        {/* left Top */}
        <div className="mr-1 flex h-[100%] flex-col gap-4">
          <div className="aspect-video w-full animate-pulse rounded bg-slate-300"></div>
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-4">
              <div className="col-span-2 h-2 rounded bg-slate-300"></div>
              <div className="col-span-1 h-2 rounded bg-slate-300"></div>
            </div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 w-[100px] rounded bg-slate-300"></div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="mb-3 w-[100%] animate-pulse">
          <div className="space-y-3">
            <div className="h-2 w-[200px] rounded bg-slate-300"></div>

            <div className="h-2 w-[200px] rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="w-[100px]rounded  h-2 bg-slate-300"></div>
            <div className="h-2 w-[100px] rounded bg-slate-300"></div>
          </div>
        </div>
        <div className="w-[100%] animate-pulse">
          <div className="space-y-3">
            <div className="h-2 w-[200px] rounded bg-slate-300"></div>

            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 w-[100px] rounded bg-slate-300"></div>
          </div>
        </div>
      </div>

      <div className="ml-2 flex w-[25%] flex-col">
        {/* left Top */}
        <div className="mr-1 flex h-[100%] flex-col gap-4">
          <div className="aspect-video w-full animate-pulse rounded bg-slate-300"></div>
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-4">
              <div className="col-span-2 h-2 rounded bg-slate-300"></div>
              <div className="col-span-1 h-2 rounded bg-slate-300"></div>
            </div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 w-[100px] rounded bg-slate-300"></div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="mb-3 w-[100%] animate-pulse">
          <div className="space-y-3">
            <div className="h-2 w-[200px] rounded bg-slate-300"></div>

            <div className="h-2 w-[200px] rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="w-[100px]rounded  h-2 bg-slate-300"></div>
            <div className="h-2 w-[100px] rounded bg-slate-300"></div>
          </div>
        </div>
        <div className="w-[100%] animate-pulse">
          <div className="space-y-3">
            <div className="h-2 w-[200px] rounded bg-slate-300"></div>

            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 rounded bg-slate-300"></div>
            <div className="h-2 w-[100px] rounded bg-slate-300"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwoCompoentColSkeleton;
